import React from "react";
import { format } from "date-fns";
import { fullDateLongFormat } from "@common/helpers/date";

interface Props {
    start?: Date;
    end?: Date;
}

export const DateRangeFilterLabel: React.FC<Props> = ({ start, end }) => {
    if (!start && !end) {
        return null;
    }

    if (start && end) {
        return (
            <span>
                {format(start, fullDateLongFormat)} -{" "}
                {format(end, fullDateLongFormat)}
            </span>
        );
    }

    if (start) {
        return <span>From {format(start, fullDateLongFormat)}</span>;
    }

    if (end) {
        return <span>Until {format(end, fullDateLongFormat)}</span>;
    }

    return null;
};
